// @ts-ignore
import currencyFormatter from 'currency-formatter';

import { getSeparators } from '../number';

export interface CurrencyConfig {
  useSymbol?: boolean;
  useDecimals?: boolean;
  forceDeltaSymbol?: boolean;
  spaceOutSymbol?: boolean;
}

// This is a temporay solution to convert cents to dollar values while formating currency.
// Ideally it would be better if formatCurrency() can take original value (ie cents) and do conversion and format based on locale for unification
export const formatCurrencyFromCents = (
  val: number = 0,
  config: CurrencyConfig = {},
): string => formatCurrency(val / 100, config);

export default function formatCurrency(val = 0, config: CurrencyConfig = {}) {
  const {
    useSymbol = true,
    useDecimals = val % 1 !== 0,
    forceDeltaSymbol = false,
    spaceOutSymbol = false,
  } = config;
  if (forceDeltaSymbol && spaceOutSymbol) {
    throw new Error(
      'The use of both forceDeltaSymbol and spaceOutSymbol is not supported',
    );
  }
  let format: {
    pos: string;
    neg: string;
    zero: string;
  };
  if (forceDeltaSymbol) {
    format = {
      pos: '+%s%v',
      neg: '-%s%v',
      zero: '%s%v',
    };
  }
  if (spaceOutSymbol) {
    format = {
      pos: '%s %v',
      neg: '-%s %v',
      zero: '%s %v',
    };
  }
  return currencyFormatter.format(val, {
    precision: useDecimals ? 2 : 0,
    symbol: useSymbol ? '$' : '',
    thousand: getSeparators().group,
    // @ts-ignore
    format,
  });
}
